import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/categories';

const avatarUrls: Record<string, string> = {
  'avatar-01': 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20european%20man%20with%20casual%20style%20warm%20friendly%20expression%20clean%20light%20cream%20background%20soft%20natural%20lighting%20editorial%20portrait%20photography%20high%20detail&width=120&height=120&seq=avatar-01&orientation=squarish',
  'avatar-02': 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20european%20woman%20with%20modern%20fashion%20style%20confident%20friendly%20expression%20clean%20light%20cream%20background%20soft%20natural%20lighting%20editorial%20portrait%20photography%20high%20detail&width=120&height=120&seq=avatar-02&orientation=squarish',
  'avatar-03': 'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20young%20man%20with%20streetwear%20style%20friendly%20smile%20clean%20light%20cream%20background%20soft%20natural%20lighting%20editorial%20portrait%20photography%20high%20detail%20european%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
  'avatar-04': 'https://readdy.ai/api/search-image?query=Warm%20portrait%20of%20young%20european%20woman%20with%20minimalist%20style%20genuine%20smile%20clean%20light%20cream%20background%20soft%20natural%20lighting%20editorial%20portrait%20photography%20high%20detail%20professional%20yet%20friendly&width=120&height=120&seq=avatar-04&orientation=squarish',
  'avatar-05': 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20man%20with%20smart%20casual%20style%20warm%20confident%20expression%20clean%20light%20cream%20background%20soft%20natural%20lighting%20editorial%20portrait%20photography%20high%20detail%20european%20aesthetic&width=120&height=120&seq=avatar-05&orientation=squarish',
};

const cardBgUrl = 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20product%20photography%20of%20fashion%20lifestyle%20scene%20with%20laptop%20and%20fashion%20items%20on%20light%20cream%20desk%20warm%20natural%20daylight%20clean%20european%20aesthetic%20editorial%20style%20high%20detail%20airy%20atmosphere&width=600&height=400&seq=testimonial-card&orientation=landscape';

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-2 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-3">
            <i className="ri-star-line"></i>
            Editor Picks
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-light">
            Spreadsheet Reviews
            <span className="font-semibold"> &amp; Guides</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="bg-secondary-50 rounded-lg p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={avatarUrls['avatar-01']}
                alt={testimonials[0].name}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonials[0].name}</p>
                <p className="text-xs text-foreground-400">{testimonials[0].role}</p>
              </div>
            </div>
            <i className="ri-chat-quote-line text-xl text-secondary-300 mb-2 block"></i>
            <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[0].text}</p>
          </div>

          <div className="bg-secondary-50 rounded-lg p-5 md:p-6">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={avatarUrls['avatar-02']}
                alt={testimonials[1].name}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-900">{testimonials[1].name}</p>
                <p className="text-xs text-foreground-400">{testimonials[1].role}</p>
              </div>
            </div>
            <i className="ri-chat-quote-line text-xl text-secondary-300 mb-2 block"></i>
            <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[1].text}</p>
          </div>

          <div className="relative rounded-lg overflow-hidden cursor-pointer group">
            <img
              src={cardBgUrl}
              alt="Testimonial background"
              className="w-full h-full object-cover absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
            <div className="relative z-10 p-5 md:p-6 flex flex-col justify-end h-full min-h-[200px]">
              <p className="text-white text-sm font-semibold">{testimonials[2].name}</p>
              <p className="text-white/60 text-xs">{testimonials[2].role}</p>
              <p className="mt-2 text-white/80 text-xs leading-relaxed line-clamp-3">{testimonials[2].text}</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          <Link
            to="/article-gtbuy-sheet"
            className="md:col-span-2 relative rounded-lg overflow-hidden cursor-pointer group"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20photography%20with%20laptop%20displaying%20spreadsheet%20data%20and%20product%20images%20on%20light%20cream%20desk%20soft%20natural%20daylight%20editorial%20style%20european%20aesthetic%20high%20detail%20airy%20atmosphere%20productivity%20theme&width=900&height=400&seq=seo-article-card&orientation=landscape"
              alt="GTBuy SEO Guide"
              className="w-full h-56 md:h-64 object-cover absolute inset-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-900/80 via-primary-900/30 to-transparent"></div>
            <div className="relative z-10 p-5 md:p-6 flex flex-col justify-end h-full min-h-[224px] md:min-h-[256px]">
              <p className="text-white text-lg md:text-xl font-heading font-semibold">GTBuy SEO Guide</p>
              <p className="text-white/60 text-xs md:text-sm mt-1">2026 Updated</p>
              <p className="mt-2 text-white/80 text-sm leading-relaxed max-w-md">
                Deep dive into gtbuy sheet comparison logic &mdash; learn how structured spreadsheet data outperforms traditional review-based shopping.
              </p>
              <span className="mt-3 text-white/50 text-xs">
                <i className="ri-arrow-left-line"></i> Back to GTBuy.art Home
              </span>
            </div>
          </Link>

          <div className="flex flex-col gap-4 md:gap-5">
            <div className="bg-secondary-50 rounded-lg p-4 md:p-5 flex-1">
              <i className="ri-chat-quote-line text-lg text-secondary-300 mb-2 block"></i>
              <p className="text-xs md:text-sm text-foreground-700 leading-relaxed mb-3">{testimonials[3].text}</p>
              <div className="flex items-center gap-2.5">
                <img
                  src={avatarUrls['avatar-04']}
                  alt={testimonials[3].name}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-900">{testimonials[3].name}</p>
                  <p className="text-xs text-foreground-400">{testimonials[3].role}</p>
                </div>
              </div>
            </div>
            <div className="bg-secondary-50 rounded-lg p-4 md:p-5 flex-1">
              <i className="ri-chat-quote-line text-lg text-secondary-300 mb-2 block"></i>
              <p className="text-xs md:text-sm text-foreground-700 leading-relaxed mb-3">{testimonials[4].text}</p>
              <div className="flex items-center gap-2.5">
                <img
                  src={avatarUrls['avatar-05']}
                  alt={testimonials[4].name}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <div>
                  <p className="text-xs font-semibold text-foreground-900">{testimonials[4].name}</p>
                  <p className="text-xs text-foreground-400">{testimonials[4].role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}